// @flow
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Icon from 'Common/Icon';
import * as R from 'ramda';

import classNames from 'classnames';
import updateQueryString from 'Common/updateQueryString';
import { sortByValues } from 'Common/filterValues';
import { createValue, getKey } from 'Common/formValues';
import { gtmEventPush } from 'utils/gtm/events';

import styles from 'components/SortBy.scss';

const getSorter = i => {
  const sortDef = R.find(R.propEq('key', getKey(i)))(sortByValues);

  return [
    { key: 'sortBy', val: sortDef.sortBy },
    { key: 'sort', val: sortDef.sort }
  ];
};

const isDistance = val => {
  return getKey(val) === 'distance';
};

/**
 * <SortBy /> component.
 */
class SortBy extends PureComponent<*, *> {
  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   */
  static propTypes = {
    isFilterMode: PropTypes.bool,
    selectedValue: PropTypes.string,
    isPostcode: PropTypes.string
  };

  fadeOutAfter = delay => {
    setTimeout(
      () =>
        this.setState({
          showMessage: false
        }),
      delay
    );
  };

  handleSortChange = (e: SyntheticEvent) => {
    const value = e.target.value;
    const displayName = JSON.parse(value).display;
    gtmEventPush({
      method: 'adListings',
      args: {
        itemLabel: `Sort by: ${displayName}`
      }
    });

    const sorter = getSorter(value);
    const { isPostcode } = this.props;
    if (isDistance(value) && !isPostcode) {
      this.setState({ showMessage: true });
      this.fadeOutAfter(3000);
    } else {
      this.setState({ showMessage: false });
      updateQueryString(sorter);
    }
  };

  /**
   * Renders <SortBy /> component.
   *
   * @return {JSX} - renders a SortBy.
   */
  render() {
    const { isFilterMode, selectedValue } = this.props;
    return (
      <div
        className={classNames(
          styles.sortBy,
          isFilterMode ? styles.filterMode : null
        )}
      >
        {this.state && this.state.showMessage && (
          <p className={styles.message}>Please add postcode</p>
        )}
        <label htmlFor="sortBy">Sort by:</label>

        <Field
          name={'sortBy'}
          onChange={this.handleSortChange}
          component="select"
          value={selectedValue}
        >
          {sortByValues.map((_, i) => (
            <option key={i} value={createValue(_)}>
              {_.display}
            </option>
          ))}
        </Field>

        <Icon
          iconName={'angle-down'}
          size={'default'}
          className={styles.icon}
        />
      </div>
    );
  }
}

export default SortBy;



// WEBPACK FOOTER //
// ./src/Results/SortBy/index.js